import { createApp, h } from 'vue';
import App from './App.vue';
import Router from './router';
import Store from './store';

import VueTheMask from 'vue-the-mask';

import 'vue-universal-modal/dist/index.css';
import VueUniversalModal from 'vue-universal-modal';

import Control from './elements/Control';
import Group from './elements/Group';
import RadioGroup from './elements/RadioGroup';
import Bundle from './elements/Bundle';
import Field from './elements/Field';
import Error from './elements/Error';
import FieldRow from './elements/FieldRow';

window.addEventListener('DOMContentLoaded', () => {
  const hooks = [...document.querySelectorAll('.forms_v2')];

  if (!hooks.length) return;
  hooks.forEach(hook => {
    const container = document.createElement('div');
    container.setAttribute('id', hook.dataset.formId);
    document.body.insertAdjacentElement('afterbegin', container);

    const store = new Store();
    const router = new Router(store, hook.dataset.baseUrl);
    const context = { ...hook.dataset };
    const app = createApp({
      render: () => h(App, context),
    });

    app
      .use(VueUniversalModal, { teleportTarget: '#forms_v2-modal-area' })
      .use(store)
      .use(router)
      .use(VueTheMask)
      .component('bundle', Bundle)
      .component('control', Control)
      .component('group', Group)
      .component('radio-group', RadioGroup)
      .component('field', Field)
      .component('error', Error)
      .component('field-row', FieldRow)
      .mount(hook);
  });
});
